// feature name
import {
  ActionsEnum,
  FetchUnmatchedPaymentsSuccess,
} from './invoice-match-payments-data.actions';
import { handleActions } from 'redux-actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UnmatchedPaymentsWithClients } from './models/unmatched-payments-with-clients.model';

export const FEATURE_NAME = 'invoice-match-payments-data';

// state interface
export interface IState {
  unmatchedPayments: UnmatchedPaymentsWithClients;
}

// initial states of store
export const initialState: IState = {
  unmatchedPayments: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.FETCH_UNMATCHED_PAYMENTS_SUCCESS]: function (
      state: IState,
      { payload }: FetchUnmatchedPaymentsSuccess
    ): IState {
      return {
        ...state,
        unmatchedPayments: payload.unmatchedPayments,
      };
    },
  },
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);
export const getUnmatchedPayments = createSelector(
  selectFeature,
  (state: IState) => state.unmatchedPayments
);
